// Resolve the Reported Model attribute that matches a given part type. Models
// are configured at the client/contract level with a list of applicable
// part-type ids; the matching enabled option is what we auto-fill when the
// user picks a serial (helpdesk flow) or a part type (client/customer flow).
//
// Lives in its own file (rather than utils/services.ts) so the helper can be
// imported without dragging in services.ts's pre-existing `any` baggage —
// keeps lint-staged green for callers outside that file.

export interface PartTypeModelOption {
  id: number | string;
  value?: {
    clientModelName?: string;
    enabled?: boolean;
    partType?: number[];
    [key: string]: unknown;
  };
}

export const resolveModelForPartType = <T extends PartTypeModelOption>(
  options: T[] | undefined,
  partTypeId: number | undefined
): T | undefined => {
  if (!options?.length || partTypeId == null) return undefined;
  return options.find((opt) => opt.value?.enabled && opt.value?.partType?.includes(partTypeId));
};
